export interface SizeLabelSource {
    sizeName: string;
    usSize?: string;
}

export function getDisplaySizeName(
    item: SizeLabelSource,
    showUsSizes: boolean
): string {
    if (showUsSizes) {
        const us = item.usSize ? item.usSize.trim() : '';
        if (us) {
            return us;
        }
    }
    return item.sizeName || '';
}
